export default __webpack_public_path__ + "static/media/LogoWeb.9d4bcef8.png";